import React, {Component /*, Fragment*/} from 'react';

export default class About extends Component{
    render(){
        return <h1>This is About Page</h1>
    }
}
